module.exports = __webpack_public_path__ + "img/pictoPresentation4.9d20761a.svg";